import { useInfoPopup } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { editProfile } from 'store/actionCreators/profile';
import { getFullAuthUser } from 'store/selectors/auth';

import { FIELDS, useAllowedToEditForm } from './form';

export const useChangeAllowedToEdit = (
  defaultValues: { value: string; label: string }[],
) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const { showInfoPopup } = useInfoPopup();
  const user = useSelector(getFullAuthUser);
  const { handleSubmit, setValue, ...form } =
    useAllowedToEditForm(defaultValues);

  const onSubmit = handleSubmit(async (values) => {
    dispatch(
      editProfile({
        data: {
          [FIELDS.ALLOWED_TO_EDIT]: JSON.stringify(
            values[FIELDS.ALLOWED_TO_EDIT].map((i) => i.value),
          ),
        },
        id: user.id,
        onSuccess: () => {
          showInfoPopup({
            type: 'success',
            title: t('common.editSuccess.title'),
            message: t('profile.editSuccess'),
            duration: 3000,
            noButton: true,
            loop: false,
          });
        },
        onFailure: () => {
          addToast(t('errors.text500'), {
            appearance: 'error',
            autoDismiss: true,
          });
        },
      }),
    );
  });

  return {
    onSubmit,
    setValue,
    ...form,
  };
};
